import dynamic from "next/dynamic";
//import Link from "next/link";
import styles from "./news.module.scss";
import {
  Fragment,
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
  useContext,
} from "react";
import {
  convertToISO8601,
  publishedDateFormat,
  publishedDateFormat2,
  isDateTimePassed,
  convertDateTime,
  convertToIST,
} from "@/utils/dateTimeFormat";
import { getPlainText, useProgressiveParagraphs } from "@/utils/articleHtmlSplit";
import siteInfo from "@/constants/siteInfo";
import defaultAuthor from "@/constants/defaultAuthor";
import textLanguage from "@/constants/textLanguage";
// const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
import sendGAEvent from "@/utils/gaEvent";
import useIsMobile from "@/hooks/useIsMobile";
// const Sponsor = dynamic(() => import("@/component/Sponsor"));
const RecengineWidget = dynamic(() => import("@/component/RecengineWidget"), {
  loading: () => <></>,
});
import { getDataFromSSR } from "@/handlers/client/commonClient";
import { useRouter } from "next/router";
import Cookies from "js-cookie";
// import StateExitPoll from "@/component/StateExitPoll";
// import StateResultTally from "@/component/StateResultTally";
// import { useWindowSize } from "@/hooks/useIsMobile";
const VODPlayer = dynamic(() => import("@/component/VODPlayer"), { ssr: true });
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const SocialShare = dynamic(() => import("@/component/SocialShare"),{ssr:true});
const RelatedNews = dynamic(() => import("@/component/RelatedNews"), {
  loading: () => <></>,
});
const LiveBlog = dynamic(() => import("@/component/LiveBlog"));
const HighLights = dynamic(() => import("@/component/Highlights"));
const LiveBlogSchema = dynamic(() =>
  import("@/component/SeoTags/LiveBlogSchema")
);
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const NewsArticleSchema = dynamic(() =>
  import("@/component/SeoTags/NewsArticleSchema")
);
const NewsArticleSchema1 = dynamic(() =>
  import("@/component/SeoTags/NewsArticleSchema1")
);
const PhotoGallerySchema = dynamic(() =>
  import("@/component/SeoTags/PhotoGallerySchema")
);
const VideoObjectSchema = dynamic(() =>
  import("@/component/SeoTags/VideoObjectSchema")
);
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
const ProfilePageSchema = dynamic(() =>
  import("@/component/SeoTags/ProfilePageSchema")
);

// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );

const PersonSchema = dynamic(() => import("@/component/SeoTags/PersonSchema"));
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
const TaboolaScript = dynamic(() => import("@/component/Ads/TaboolaScript"), { ssr: false });
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
// const JWPlayer = dynamic(() => import("@jwplayer/jwplayer-react"), {
//   ssr: false,
// });
import SVG from "react-inlinesvg";
import { RWebShare } from "react-web-share";
const PhotoView = dynamic(() => import("@/screens/PhotosView"), { ssr: false });
// const StateResultTally = dynamic(() => import("@/component/StateResultTally"), {
//   ssr: false,
// });
const asset_url = process.env.NEXT_PUBLIC_ASSET_URL;
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import { MasterConfigContext } from "@/context/MasterConfigContext";
// import ElectionLive from "@/component/ElectionLive";

const Detail = ({
  newsData = null,
  isLiveBlog = false,
  electionLiveData = null,
}) => {
  const [newsDataLive, setNewsData] = useState(newsData);
  console.log("newsDataLive", newsDataLive);
  const defaultCount = newsData?.content?.length;
  const isAutoLiveBlog = newsData?.type == "live_blog" ? true : false;
  // newsData?.autoblog_stop_editing == 0 && newsData?.autoblog_post != ""
  //   ? true
  //   : false;
  const storyId = newsData?.id ? newsData?.id : null;
  useEffect(() => {
    if (!isAutoLiveBlog || !storyId) return;

    const fetchData = async () => {
      try {
        const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
        const fetchedData = await getDataFromSSR(
          `${websiteUrl}/api/getStoryDetail?id=${storyId}`
        );

        const newContent = fetchedData?.data?.newsData?.content || [];
        const contentLength = newContent.length;
        // console.log("newContent",newContent)

        setNewsData((prev) => {
          const prevIds = new Set(prev.content.map((item) => item.id));
          const freshContent = newContent?.filter(
            (item) => !prevIds.has(item.id)
          );

          if (freshContent.length === 0) return prev;

          return {
            ...prev,
            content: [...freshContent, ...prev.content], // prepend or append depending on sort order
          };
        });
      } catch (error) {
        console.error("Error in liveblog fetchData:", error);
      }
    };

    // Run immediately, then poll every 30s
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [isAutoLiveBlog]);


  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false)
  // live blog via on scroll also
  async function fetchMoreEvents() {
    if (loading || !hasMore || !storyId) return;

    const nextPage = page + 1;

    try {
      setLoading(true);

      const res = await getDataFromSSR(
        `${process.env.NEXT_PUBLIC_WEBSITE_URL}/api/getLiveBlogEventsPagination?page=${nextPage}&id=${storyId}`
      );

      const responseData = res?.data?.liveBlogEvents || {};
      const olderEvents = responseData?.content || [];
      const canLoadMore = responseData?.is_load_more ?? false;

      if (olderEvents.length === 0) {
        setHasMore(false);
        return;
      }

      setNewsData((prev) => {
        const map = new Map();

        [...prev.content, ...olderEvents]?.forEach(item => {
          map?.set(item.id, item);  
        });

        return {
          ...prev,
          content: Array.from(map.values()),
        };
      });

      setPage(nextPage);
      setHasMore(canLoadMore);
    } catch (err) {
      console.error("Load more error:", err);
    } finally {
      setLoading(false);
    }
  }
  //  for youtube tv----
  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";
    electionLiveData?.content &&
      Object?.keys(electionLiveData?.content).forEach((key) => {
        if (
          first === false &&
          electionLiveData?.content?.[key]?.status === "1"
        ) {
          firstActiveItem = key;
          first = true;
        }
      });
    return firstActiveItem;
  }, []);
  let websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
  // const size = useWindowSize();
  let paragraphs = useProgressiveParagraphs(newsData?.description);
  const isBreakingNews = newsData?.type === "breaking_new";
  const showHighLight = newsData?.highlight?.length > 0 ? true : false;
  const isLiveEnded =
    isLiveBlog && newsData?.live_blog_end_time
      ? isDateTimePassed(newsData?.live_blog_end_time)
      : false;
  const isTwitter = newsData?.description.includes("platform.twitter.com");
  const isInsta = newsData?.description.includes("instagram.com/embed.js");
  const isMobileDevice = useIsMobile();
  const [recArticles, setRecArticles] = useState([]);
  // const [showMore, setShowMore] = useState(true);
  const router = useRouter();
  const isRajasthan = router?.asPath?.includes("/rajasthan");
  const isMadhya = router?.asPath?.includes("/madhya-pradesh");
  const isHR = router?.asPath?.includes("/haryana");
  const isBH = router?.asPath?.includes("/bihar");
  const isUP = router?.asPath?.includes("/uttar-pradesh");
  const isCGH = router?.asPath?.includes("/chhattisgarh");
  const isUK = router?.asPath?.includes("/uttarakhand");
  const masterConfig = useContext(MasterConfigContext);
  const breakingNewsKey = masterConfig["breaking_news"];
  const isNoIndex = router?.asPath?.includes("/xiaomi-astrology");
  const eventRef = useRef(false);
  const urlPath = newsData?.seo_detail?.canonical_url; // Get the current path
  const segments = urlPath?.split("/"); // Split by '/'
  const lastSegment = segments?.pop(); // Get the last segment
  const keyBindings = {
    Category: [
      newsData?.category_detail?.eng_title ?? router?.asPath.split("/")[1],
      newsData?.content_type,
      newsData?.id,
    ],
    Keywords: newsData?.seo_detail?.meta_keyword.split(","),
  };

  // Remove any date format at the end (like -YYYY-MM-DD) and any remaining hyphens
  const cleanSegment = lastSegment
    ?.replace(/-\d{8}-\d{4}-\d{2}-\d{2}$/, "") // Remove date in the format -YYYYMMDD
    ?.replace(/-\d{1,2}-\d{1,2}-\d{1,4}$/, "") // Remove date in the format -DD-MM-YYYY or -MM-DD-YYYY
    ?.replace(/\b\d{4,}\b/g, "") // Remove large numbers (e.g., 3104752, 2024)
    ?.replace(/(\d{1,2}(st|nd|rd|th)?\b|\b\d{1,2})/g, "") // Remove ordinal or standalone numbers (e.g., 10th, 28th, or 10, 28)
    ?.replace(/-/g, " ") // Replace remaining hyphens with spaces
    ?.trim(); // Remove leading or trailing whitespace

  // console.log("newsData", cleanSegment);

  const isPhotoGallery = newsData?.type === "photo_gallery";
  const [showPhoto, setShowPhoto] = useState(false);
  const [visibleId, setVisibleId] = useState(null);
  const [scrollDirection, setScrollDirection] = useState("down");
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [currentId, setCurrentId] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const [showBreaking, setShowBreaking] = useState(false);
  const [breakingNews, setBreakingNews] = useState(null);
  const taboolaPage = newsData?.content_type == "story" ? "article" : newsData?.content_type == "photo_gallery" ? "photo" : newsData?.content_type;

  const handleBreakingStripClose = () => {
    sessionStorage.setItem("breaking_strip", false);
    setShowBreaking(false);
  };

  useEffect(() => {
    const fetchBreakingNews = async () => {
      try {
        if (newsData?.content_type !== "story") return;
        const time = Date.now();
        const breakingNewsData = await getDataFromSSR(
          `${process.env.NEXT_PUBLIC_WEBSITE_URL}/api/getBreakingNews`
        );
        const breakingNewsRes = breakingNewsData?.data?.breakingNewsData;
        if (!breakingNewsRes) return;
        const exp = breakingNewsRes?.content?.datetime; // "2025-09-19 12:21:14"
        let expired = false;
        if (exp) {
          const parsed = new Date(exp.replace(" ", "T"));
          expired = Date.now() > parsed.getTime();
        }
        const checkBreaking =
          breakingNewsRes &&
          breakingNewsRes?.content &&
          !breakingNewsRes?.content?.canonical_url?.includes(router?.asPath);
        console.log(
          "CHECK BREAKING",
          checkBreaking,
          router?.asPath,
          breakingNewsRes?.content?.canonical_url
        );
        if (
          !expired &&
          !sessionStorage.getItem("breaking_strip") &&
          checkBreaking
        ) {
          setShowBreaking(true);
          setBreakingNews(breakingNewsRes);
        }
      } catch (err) {
        console.err("Error while fetching breaking news!", err.message);
      }
    };
    fetchBreakingNews();
  }, []);

  const divRefs = useRef([]);
  const scrollTimeout = useRef(null);

  const handleShowPhoto = (id) => {
    setShowPhoto(true);
    setCurrentId(id);
    // console.log(showPhoto);
  };

  useEffect(() => {
    async function onFirstScroll() {
      // setFirstScroll(true);
      if (isTwitter) {
        const script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        script.defer = true;
        document.body.appendChild(script);
        window?.twttr?.widgets.load();
      }
      if (isInsta) {
        const script1 = document.createElement("script");
        script1.src = "https://www.instagram.com/embed.js";
        script1.defer = true;
        document.body.appendChild(script1);
        window.instgrm?.Embeds.process();
      }
      if (!scrolled) {
        setScrolled(true);
      }
    }

    function handleScroll() {
      onFirstScroll();

      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
  }, []);

  // This function waits for gtag to be ready
  const waitForGtag = () => {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (typeof window.gtag === "function") {
          clearInterval(checkInterval);
          resolve();
        }
      }, 50);
    });
  };

  useEffect(() => {
    if (eventRef.current) {
      return;
    }
    const sendEvent = async () => {
      await waitForGtag();
      window.gtag("event", "page_view_author", {
        page_title: document.title,
        author_name: newsData?.cms_user_name || defaultAuthor.title,
        page_location: window.location.href,
        send_to: process.env.NEXT_PUBLIC_GACODE ?? "",
      });
      eventRef.current = true;
    };
    if (!eventRef.current) {
      sendEvent();
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      let mtf2 = false;
      window.googletag = window.googletag || { cmd: [] };
      // console.log("Window width ", window.screen.width);
      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          // console.log("dp slots");

          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            {
              document.getElementById("div-gpt-ad-1659434604998-0") &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                    [300, 250],
                    "div-gpt-ad-1659434604998-0"
                  )
                  ?.addService(googletag.pubads());
            }
            if (
              (newsData?.type === "video" && paragraphs[4]) ||
              (newsData?.type === "story" && paragraphs[5]) ||
              newsData?.content?.length >= 6 ||
              newsData?.photo?.length >= 4
            ) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434785315-0"
                )
                ?.addService(googletag.pubads());
            }
            if ((paragraphs && paragraphs[6]) || newsData?.photo?.length >= 6) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-3_300x250",
                  [300, 250],
                  "div-gpt-ad-1659435328239-0"
                )
                ?.addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              ?.addService(googletag.pubads());
          }
          if (!scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());
          }

          // // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();

          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });

          !scrolled &&
            googletag.cmd.push(function () {
              var INTERSTITIALAd = googletag
                .defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                  googletag.enums.OutOfPageFormat.INTERSTITIAL
                )
                .addService(googletag.pubads());

              INTERSTITIALAd && googletag.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              ?.addService(googletag.pubads());
           document.getElementById("div-gpt-ad-1707804176041-1")&& googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            if (
              (isLiveBlog || isBreakingNews) &&
              newsData?.content?.length > 2
            ) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                  [728, 90],
                  "div-gpt-ad-1707804176041-2"
                )
                ?.addService(googletag.pubads());
            }
            if (
              !(isLiveBlog || isBreakingNews) ||
              newsData?.photo?.length >= 2
            ) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                  [728, 90],
                  "div-gpt-ad-1707804176041-2"
                )
                ?.addService(googletag.pubads());
            }

            if (
              (paragraphs && paragraphs[5]) ||
              isBreakingNews ||
              isLiveBlog ||
              newsData?.content?.length > 6 ||
              newsData?.photo?.length >= 4
            ) {
              if (document.getElementById("div-gpt-ad-1707804176041-3")) {
                mtf2 = true;
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                    [728, 90],
                    "div-gpt-ad-1707804176041-3"
                  )
                  ?.addService(googletag.pubads());
              }
            }

            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              ?.addService(googletag.pubads());
          }

          // // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }

      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: true, mtf3: true, btf: true })
                : createApsSlotsRosDesktop({
                  mtf2: mtf2,
                  mtf3: false,
                  btf: true,
                }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
      let imagesTagsWithDataSrc = document.querySelectorAll("[data-src]");
      if (imagesTagsWithDataSrc && imagesTagsWithDataSrc?.length > 0) {
        imagesTagsWithDataSrc.forEach(function (el) {
          el.src = el.getAttribute("data-src");
          el.loading = "lazy";
          el.removeAttribute("data-src");
        });
      }
    }, 10);
  }, [scrolled]);

  //handle url update for each photo scroll
  const handlePhotoScroll = useCallback(() => {
    if (isPhotoGallery) {
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current); // Clear previous timeout
      }

      // Set a new timeout to debounce the scroll handler
      scrollTimeout.current = setTimeout(() => {
        divRefs.current.forEach((div) => {
          if (div) {
            const rect = div.getBoundingClientRect();
            const scrollRatio = isMobileDevice ? 2 : 2;
            // Check if the element is in the viewport (at least 50% visible)
            if (rect.top >= 0 && rect.top < window.innerHeight / scrollRatio) {
              const id = div.id;
              if (id !== visibleId) {
                setVisibleId(id);
                const newUrl = `${websiteUrl}${newsData?.seo_detail?.canonical_url}-${id}`;
                window.history.replaceState(null, "", newUrl);
                // router.push(`#${id}`, undefined, { shallow: true });
              }
            }
          }
        });
      }, 10); // 10ms debounce
    }
  }, [isPhotoGallery, visibleId]);

  const handleNavigation = useCallback(
    (e) => {
      if (isPhotoGallery) {
        if (y > window.scrollY) {
          setScrollDirection("up");
        } else if (y < window.scrollY) {
          setScrollDirection("down");
        }

        setY(window.scrollY);
      }
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    const thresholds = [10, 25, 50, 75, 100];
    const triggered = new Set();
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const target = document.getElementById("endDiv");
          if (!target) return;

          const targetBottom = target.offsetTop;
          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const scrollPercent = Math.floor((scrollTop / targetBottom) * 100);

          thresholds.forEach((percent) => {
            if (scrollPercent >= percent && !triggered.has(percent)) {
              triggered.add(percent);
              window.gtag("event", "story_scroll", {
                page_title: document.title,
                page_location: window.location.href,
                event_category: "Engagement",
                event_label: `${percent}%`,
                value: percent,
                send_to: process.env.NEXT_PUBLIC_GACODE ?? "",
              });
              console.log(`Scroll depth ${percent}% reached`);
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Attach the scroll event listener
    window.addEventListener("scroll", handlePhotoScroll, { passive: true });
    //comscore call for each photo scroll
    if (isPhotoGallery) {
      if (visibleId != currentId && scrollDirection == "down") {
        if (
          window.COMSCORE &&
          window.COMSCORE.beacon &&
          !window._comscoreFired
        ) {
          window.COMSCORE.beacon({ c1: "2", c2: "8549097", c3: visibleId });
          window._comscoreFired = true;
          setCurrentId(visibleId);
        }
      }
    }

    const comscoreTimeOut = setTimeout(() => {
      window._comscoreFired = false;
    }, 500);
    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handlePhotoScroll);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current); // Cleanup any remaining timeouts
        clearTimeout(comscoreTimeOut);
      }
    };
  }, [visibleId]);

  useEffect(() => {
    if (isPhotoGallery) {
      const url = window.location.href;
      const id = url.split("-").pop();

      // If ID exists, try to scroll to the element with that ID
      if (id) {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }, []);
  const articlesFetched = useMemo(() => {
    if (recArticles && recArticles.length > 0) {
      return true;
    }
    return false;
  }, [recArticles]);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  let lastScrollTop = 0;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollTop < lastScrollTop) {
        setIsScrollingUp(true);
      } else {
        setIsScrollingUp(false);
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  //fetch recengine articles
  const showRecEngine= masterConfig?.showRecEngine
  useEffect(() => {
    async function fetchArticles() {
      const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      const uid =
        Cookies.get("sp_itgd", { path: "/", domain: ".intoday.in" }) ??
        Cookies.get("sp", { path: "/", domain: ".intoday.in" }) ??
        "1234";
      const mixArticles = await getDataFromSSR(
        `${process.env.NEXT_PUBLIC_RECENGINE_BASE_PATH}/getmixarticles?model=nwtak&newsid=${newsData?.id}&uid=${uid}&utm_source=recengine&utm_medium=WEB&no=10`
      );
      // console.log("mixArticles", mixArticles?.data?.data);
      setRecArticles(mixArticles?.data);
    }
    if (!articlesFetched) {
     showRecEngine && scrolled &&  fetchArticles();
    }
  }, [scrolled]);

  useEffect(() => {
    function sendRecengineEvent() {
      let currentPath = router.asPath;
      // console.log("RECENGINE",currentPath.includes("recengine"))
      if (currentPath.includes("recengine")) {
        sendGAEvent({
          eventName: "RecengineArticle-View",
          pageTitle: document?.title,
          pageLocation: window?.location?.href,
        });
      }
    }
   showRecEngine && scrolled &&  sendRecengineEvent();
  }, [scrolled]);

  // console.log("detail", paragraphs);
  const stringSplit = (story) => {
    let arr = story;
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i] + "</p>";
    }
    var resultString = arr.join("");
    return resultString;
  };

  function extractSlugFromUrl(url) {
    // Use a regular expression to match the part of the URL after the last slash and before the hyphen followed by numbers
    const regex = /\/([^\/]+?)-\d+-\d{4}-\d{2}-\d{2}(?:#.*)?$/;
    const match = url.match(regex);
    match[1] = match[1].replace(/-/g, " ");
    if (match && match[1]) {
      // if (match[1].length > 40) {
      //   match[1] = match[1].substring(0, 40) + "...";
      // }
      return match[1];
    } else {
      return null; // Return null if the pattern isn't found
    }
  }

  const breadCrumbs = [
    ...newsData?.category_detail,
    {
      title: newsData?.title,
      canonical_url: newsData?.seo_detail?.canonical_url,
    },
  ];
    

  return (
    <section className={isLiveBlog ? "liveblog_container" : ""}>
      {/* <script
        dangerouslySetInnerHTML={{
          __html: `
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
          `,
        }}
        async
        id="mgid-component"
        type="text/javascript"
      ></script> */}
      <HeadTag
        metaTitle={
          isPhotoGallery
            ? "Newstak: " + newsData?.seo_detail?.meta_title
            : newsData?.seo_detail?.meta_title
        }
        title={
          isPhotoGallery
            ? "Newstak: " +
            (newsData?.title ?? newsData?.seo_detail?.meta_title)
            : newsData?.title ?? newsData?.seo_detail?.meta_title
        }
        description={
          isPhotoGallery
            ? newsData?.seo_detail?.meta_description + " at Newstak"
            : newsData?.seo_detail?.meta_description
        }
        image={newsData?.seo_detail?.og_image}
        keywords={newsData?.seo_detail?.meta_keyword}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          newsData?.seo_detail?.canonical_url
        }
        ampUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL + newsData?.seo_detail?.amp_url
        }
        noAuthorTag={false}
        authorName={
          newsData?.author && newsData?.author[0]
            ? newsData?.author[0]?.title
            : defaultAuthor?.title
        }
        showMaxImagePreview={true}
        articlePublishedTime={convertToISO8601(newsData?.datetime_published)}
        articleModifiedTime={
          convertToISO8601(newsData?.datetime_updated) ??
          convertToISO8601(newsData?.datetime_published)
        }
        lcpImage={null} // {`${newsData?.image_main}?w=1200&q=75&format=webp`}
        robotFollow={!isNoIndex}
      />
      {/* <GTMScript /> */}
      <WebpageSchema
        title={newsData?.title ?? newsData?.seo_detail?.meta_title}
        description={newsData?.seo_detail?.meta_description}
        keywords={newsData?.seo_detail?.meta_keyword}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          newsData?.seo_detail?.canonical_url
        }
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />
      {/* <WebsiteSchema /> */}
      {isLiveBlog ? (
        <NewsArticleSchema1
          title={newsData?.title ?? newsData?.seo_detail?.meta_title}
          description={newsData?.seo_detail?.meta_description}
          image={newsData?.seo_detail?.og_image}
          keywords={newsData?.seo_detail?.meta_keyword}
          canonical_url={newsData?.seo_detail?.canonical_url}
          publishedAt={convertToIST(newsData?.datetime_published)}
          modifiedAt={
            convertToIST(newsData?.content[0]?.datetime_updated) ||
            convertToIST(newsData?.datetime_updated)
          }
          createdAt={convertToIST(newsData?.datetime_created)}
          authorName={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.title
              : defaultAuthor?.title
          }
          authorCanonicalUrl={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.canonical_url
              : defaultAuthor?.canonical_url
          }
          articleBody={
            newsData?.description_short || getPlainText(newsData?.description)
          }
        />
      ) : (
        <NewsArticleSchema
          title={newsData?.title ?? newsData?.seo_detail?.meta_title}
          description={newsData?.seo_detail?.meta_description}
          image={newsData?.seo_detail?.og_image}
          keywords={newsData?.seo_detail?.meta_keyword}
          canonical_url={newsData?.seo_detail?.canonical_url}
          publishedAt={convertToIST(newsData?.datetime_published)}
          modifiedAt={convertToIST(newsData?.datetime_updated)}
          // createdAt={convertToIST(newsData?.datetime_created)}
          authorName={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.title
              : defaultAuthor?.title
          }
          authorCanonicalUrl={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.canonical_url
              : defaultAuthor?.canonical_url
          }
          articleBody={getPlainText(newsData?.description)}
        />
      )}
      {newsData?.type === "video" && (
        <VideoObjectSchema
          title={newsData?.title ?? newsData?.seo_detail?.meta_title}
          description={newsData?.seo_detail?.meta_description}
          image={newsData?.seo_detail?.og_image || newsData?.image_main}
          keywords={newsData?.seo_detail?.meta_keyword}
          canonical_url={newsData?.seo_detail?.canonical_url}
          publishedAt={convertToISO8601(newsData?.datetime_published)}
          modifiedAt={convertToISO8601(newsData?.datetime_updated)}
          authorName={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.title
              : defaultAuthor?.title
          }
          authorCanonicalUrl={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.canonical_url
              : defaultAuthor?.canonical_url
          }
          videoUrl={
            newsData?.mp4_url && newsData?.mp4_url[0]
              ? newsData?.mp4_url[0]?.video_url
              : ""
          }
          videoDuration={newsData?.video_duration}
          durationMinutes={newsData?.duration_m}
          durationSeconds={newsData?.duration_s}
        />
      )}
      <ProfilePageSchema
        title={newsData?.title ?? newsData?.seo_detail?.meta_title}
        canonical_url={newsData?.seo_detail?.canonical_url}
        publishedAt={convertToIST(newsData?.datetime_published)}
        authorName={
          newsData?.author && newsData?.author[0]
            ? newsData?.author[0]?.title
            : defaultAuthor?.title
        }
        authorCanonicalUrl={
          newsData?.author && newsData?.author[0]
            ? newsData?.author[0]?.canonical_url
            : defaultAuthor?.canonical_url
        }
      />
      <PersonSchema
        authorName={
          newsData?.author && newsData?.author[0]
            ? newsData?.author[0]?.title
            : defaultAuthor?.title
        }
        authorCanonicalUrl={
          newsData?.author && newsData?.author[0]
            ? newsData?.author[0]?.canonical_url
            : defaultAuthor?.canonical_url
        }
      />
      {isPhotoGallery && (
        <PhotoGallerySchema
          title={newsData?.title ?? newsData?.seo_detail?.meta_title}
          description={newsData?.seo_detail?.meta_description}
          image={newsData?.seo_detail?.og_image}
          keywords={newsData?.seo_detail?.meta_keyword}
          canonical_url={newsData?.seo_detail?.canonical_url}
          publishedAt={convertToISO8601(newsData?.datetime_published)}
          modifiedAt={convertToISO8601(newsData?.datetime_updated)}
        />
      )}
      {newsData?.type === "live_blog" && (
        <LiveBlogSchema
          liveblogData={newsData}
          authorName={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.title
              : defaultAuthor?.title
          }
          authorCanonicalUrl={
            newsData?.author && newsData?.author[0]
              ? newsData?.author[0]?.canonical_url
              : defaultAuthor?.canonical_url
          }
        />
      )}
      {/* <LiveBlogSchema liveblogData={newsData} /> */}

      {/* <VDOAdsScript /> */}
      {/* <MGIDAAdsScript delay={true} /> */}
      <TaboolaScript page={taboolaPage} isMobile={isMobileDevice} />

      {/* <div className="px-4">
        <StateExitPoll  />
      </div> */}
      {/*  <div className="px-4">
        <StateResultTally masterKey="maharashtra_election" />
      </div> */}
      <Breadcrumb
        breadcrumbList={
          newsData?.category_detail.length > 1
            ? [
              newsData?.category_detail[0],
              newsData?.category_detail[1],
              ...[
                {
                  title: cleanSegment || "",
                },
              ],
            ]
            : [
              newsData?.category_detail[0],
              ...[
                {
                  title: cleanSegment || "",
                },
              ],
            ]
        }
        isRajasthan={isRajasthan}
        isMadhya={isMadhya}
        isHR={isHR}
        isBH={isBH}
        isUP={isUP}
        isCGH={isCGH}
        isUK={isUK}
        title={
          extractSlugFromUrl(newsData?.seo_detail?.canonical_url) ??
          newsData?.seo_detail?.meta_title
        }
        titleUrl={newsData?.seo_detail?.canonical_url}
      />
      {/* breaking news strip  */}
      {showBreaking && (
        <div className="h-[3rem] md:h-fit overflow-hidden flex w-[98%] md:w-3/4 mx-auto bg-[#010930] text-white mt-4">
          <a
            href={breakingNews?.content?.canonical_url}
            className="flex items-start w-[95%]"
          >
            <img src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/breaking.png" alt="breaking_img" />
            <span className="w-full p-2 line-clamp-2 md:line-clamp-3 text-[13px] md:text-[16px] overflow-hidden">
              {breakingNews?.content?.name}
            </span>
          </a>
          <div
            onClick={handleBreakingStripClose}
            className="w-[5%] flex justify-center items-center px-1 cursor-pointer border-l border-gray-400"
          >
            <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/close.svg" className="h-8 md:h-6"></SVG>
          </div>
        </div>
      )}
      {/* <Sponsor color="#EE3436" name="चुनाव" /> */}
      {/* <StateResultTally /> */}
      <article className="mx-2 p-2">
      {isPhotoGallery && (
        <div>
          {/* {newsData?.category_detail?.map((item, index) => (
            <div
              key={index}
              className="h-7 mr-2 px-2 py-1 bg-red-500 bg-opacity-20 rounded-2xl justify-start items-start gap-3 inline-flex"
            >
              <a href={websiteUrl + item?.canonical_url}>
                <div className="text-primary text-sm">
                  {item?.title
                    ? item?.title
                    : item?.id === "breakingnews"
                    ? textLanguage.breakingNews
                    : ""}
                </div>
              </a>
            </div>
          ))} */}

          <div className="text-2xl font-bold my-2">
            <h1
              style={{ lineHeight: "30px" }}
              dangerouslySetInnerHTML={{
                __html: `${newsData?.title}`,
              }}
            />
          </div>

          {isMobileDevice && (
            <div className="bg-white w-full border-gray-200 border-y md:hidden">
              <div className="flex items-center">
                {newsData?.author && newsData?.author[0] && (
                  <p className="text-primary text-lg font-semibold pr-1">
                    <a
                      href={
                        websiteUrl +
                        (newsData?.author[0]?.canonical_url ??
                          defaultAuthor.canonical_url)
                      }
                    >
                      <h4 className={`font-semibold ${styles.author_text}`}>
                        {newsData?.author[0]?.title ?? defaultAuthor.title}
                      </h4>
                    </a>
                  </p>
                )}
                {!newsData?.author ||
                  (!newsData?.author.length && (
                    <p className="text-primary text-lg font-semibold pr-1">
                      <a href={websiteUrl + defaultAuthor.canonical_url}>
                        <h4 className="font-semibold">{defaultAuthor.title}</h4>
                      </a>
                    </p>
                  ))}
                {newsData?.datetime_updated ===
                  newsData?.datetime_published && (
                    <time
                      className={`text-gray-500 font-light ${styles.author_text}`}
                    >
                      {publishedDateFormat2(newsData?.datetime_updated)}
                    </time>
                  )}
                {newsData?.datetime_updated !==
                  newsData?.datetime_published && (
                    <time
                      className="text-slate-500 text-xs font-extralight"
                      style={{ fontSize: "13px" }}
                    >
                      {/* {console.log("first11", newsData?.datetime_updated)} */}
                      {publishedDateFormat(newsData?.datetime_published)}{" "}
                      (अपडेटेड:{" "}
                      {isLiveBlog
                        ? convertDateTime(
                          newsDataLive?.content[0]?.datetime_updated
                        )
                        : convertDateTime(newsData?.datetime_updated)}
                      )
                    </time>
                  )}
              </div>
            </div>
          )}
          {/** short description */}
          <summary
            className={`hidden text-md text-slate-500 my-2 ${newsData?.type === "video" ? "md:block" : ""
              } ${newsData?.type !== "video" ? "xs:block" : ""}`}
          >
            <h2
              className="text-lg text-[#777] italic"
              dangerouslySetInnerHTML={{
                __html: `${newsData?.description_short}`,
              }}
            />
          </summary>
          {/** author detail with date time social share */}
          <div className="hidden md:flex items-center justify-between p-2 border-b">
            <div className="flex items-center">
              <a
                href={
                  websiteUrl +
                  (newsData?.author[0]?.canonical_url ??
                    defaultAuthor.canonical_url)
                }
              >
                <img
                  src={`${newsData?.author[0]?.image ?? defaultAuthor.image
                    }?size=40:40`}
                  alt="Author Profile"
                  width="40"
                  height="40"
                  loading="lazy"
                  className="object-cover rounded-full mr-4"
                />
              </a>

              <div>
                <a
                  href={
                    websiteUrl +
                    (newsData?.author[0]?.canonical_url ??
                      defaultAuthor?.canonical_url)
                  }
                >
                  <h4 className="font-semibold">
                    {newsData?.author[0]?.title ?? defaultAuthor?.title}
                  </h4>
                </a>

                <time className="text-slate-500 text-xs font-extralight">
                  {/* {console.log("first12", newsData?.datetime_updated)} */}
                  {publishedDateFormat(
                    newsData?.datetime_published
                  )} (अपडेटेड:{" "}
                  {isLiveBlog
                    ? convertDateTime(
                      newsDataLive?.content[0]?.datetime_updated
                    )
                    : convertDateTime(newsData?.datetime_updated)}
                  )
                </time>
              </div>
            </div>

            <SocialShare
              title={newsData?.title}
              url={`${websiteUrl}${newsData?.seo_detail?.canonical_url}`}
              contentType={newsData?.type}
            />
          </div>

          {newsData?.type !== "video" && (
            <div className="block md:hidden mx-4 ">
              <AdSlot300x250
                divId="div-gpt-ad-1659434453897-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
          )}
          {/* {newsData?.type !== "video" && ( */}
          <AdSlot728x90
            divId="div-gpt-ad-1659424515060-0"
            minWidth="728px"
            minHeight="90px"
          />
          {/* )} */}
          {showPhoto && (
            <PhotoView
              newsData={newsData}
              id={currentId}
              isMobileDevice={isMobileDevice}
              setShowPhoto={setShowPhoto}
            />
          )}
          <div className="flex md:hidden items-center justify-between  mt-2 border-b">
            <SocialShare
              title={newsData?.title}
              url={`${websiteUrl}${newsData?.seo_detail?.canonical_url}`}
              contentType={newsData?.type}
            />

            <a
              href={siteInfo?.socialLinks?.googleNewsLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                sendGAEvent({
                  eventName:
                    newsData?.type === "video"
                      ? "VideoPage-GoogleNewsClick"
                      : "ArticlePage-GoogleNewsClick",
                  pageTitle: newsData?.title,
                  pageLocation: `${websiteUrl}${newsData?.seo_detail?.canonical_url}`,
                });
              }}
            >
               <img
                className="rounded-md"
                loading="eager"
                // src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/followGoogleNews.png?size=130:58"
                src={"https://akm-img-a-in.tosshub.com/lingo/uptak/resources/google.png?size=120:45"}
                alt="google news"
              width="120"
              height="45"
              />
            </a>
          </div>
          {/** hero image gallery */}
          {newsData?.photo.map((item, index) => {
            return (
              <>
                <div
                  style={{ scrollBehavior: "smooth" }}
                  ref={(el) => (divRefs.current[index] = el)}
                  id={index + 1}
                  key={index}
                  className="relative mt-8 py-4"
                >
                  <div className="w-full rounded-md">
                    <div className="relative">
                      <img
                        className="object-cover rounded-t-md"
                        src={`${item?.image_main}?size=1200:675`}
                        alt={
                          item?.image_name
                            ? item?.image_name
                            : siteInfo?.siteName
                        }
                        loading="eager"
                        priority
                        width="850"
                        height="515"
                        title={item.image_name}
                      />
                      <span
                        onClick={() => {
                          handleShowPhoto(index);
                        }}
                        className="absolute flex cursor-pointer items-center top-[1rem] right-2 p-1 w-8 h-8 md:w-10 md:h-11 rounded bg-black bg-opacity-50 text-white"
                      >
                        <SVG
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/fullscreen.svg"
                          className="w-8 h-8"
                        />
                      </span>
                      <div className="absolute flex items-center bottom-4 right-2  w-18 md:w-28 h-8 md:h-11 text-lg rounded bg-black bg-opacity-50 text-white p-2">
                        <SVG
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/gallery.svg"
                          className="w-4 h-4 md:w-6 md:h-6 mx-2"
                        />
                        <p>{index + 1 + "/" + newsData?.photo?.length}</p>
                        {/* <p className="ms-1 font-extralight">{"|"}</p> */}
                        <RWebShare
                          data={{
                            text: newsData?.title,
                            url: `${websiteUrl}${newsData?.seo_detail?.canonical_url
                              }-${index + 1}`,
                            title: newsData?.title ?? "",
                          }}
                          sites={[
                            "copy",
                            "facebook",
                            "twitter",
                            "whatsapp",
                            "mail",
                            "linkedin",
                            "reddit",
                          ]}
                        >
                          <SVG
                            className="w-4 h-4 md:w-6 md:h-6 ms-2 cursor-pointer"
                            src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/share2.svg"
                          />
                        </RWebShare>
                      </div>
                    </div>

                    {item?.image_description && (
                      <div
                        style={{ lineHeight: "1.4" }}
                        className="imgDescription w-full h-fit md:h-18 bg-black bg-opacity-80 text-white text-md md:text-lg py-2 px-4 rounded-b-md"
                        dangerouslySetInnerHTML={{
                          __html: item?.image_description,
                        }}
                      ></div>
                    )}
                  </div>
                </div>
                {index == 1 && scrolled && (
                  <div className="mx-4">
                    <AdSlot300x250
                      divId={"div-gpt-ad-1659434604998-0"}
                      minWidth="300px"
                      minHeight="250px"
                    />
                    <AdSlot728x90
                      divId={"div-gpt-ad-1707804176041-2"}
                      minWidth="720px"
                      minHeight="90px"
                    />
                  </div>
                )}
                {index == 3 && scrolled && (
                  <div className="mx-4">
                    <AdSlot300x250
                      divId={"div-gpt-ad-1659434785315-0"}
                      minWidth="300px"
                      minHeight="250px"
                    />
                    <AdSlot728x90
                      divId="div-gpt-ad-1707804176041-3"
                      minWidth="720px"
                      minHeight="90px"
                    />
                  </div>
                )}
                {index == 5 && scrolled && (
                  <div className="mx-4">
                    <AdSlot300x250
                      divId="div-gpt-ad-1659435328239-0"
                      minWidth="300px"
                      minHeight="250px"
                    />
                    {/* <AdSlot728x90
                  divId={
                    "div-gpt-ad-1707804176041-3"
                  }
                  minWidth="720px"
                  minHeight="90px"
                /> */}
                  </div>
                )}
              </>
            );
          })}

          {scrolled && (newsData?.related_story?.length > 0 ||
            newsData?.related_content?.length > 0) && (
              <RelatedNews
                relatedNewsData={
                  newsData?.related_story || newsData?.related_content
                }
                customTitle="रिलेटेड फोटो गैलरी"
              />
            )}
          {/* <div className="desktop-only-flex flex items-center my-4">
            <div className="self-center text-center md:mr-8 mb-4 md:mb-0 mr-0">
              <a
                onClick={() => {
                  sendGAEvent({
                    eventName:
                      newsData?.type === "video"
                        ? "VideoPage-GoogleNewsClick"
                        : "ArticlePage-GoogleNewsClick",
                    pageTitle: newsData?.title,
                    pageLocation: `${websiteUrl}${newsData?.seo_detail?.canonical_url}`,
                  });
                }}
                target="_blank"
                href={siteInfo?.socialLinks?.googleNewsLink}
              >
                <img
                  src={asset_url + "/followgooglenew.png?size=110:40"}
                  width="270px"
                  height={60}
                  loading="lazy"
                  alt="follow on google news"
                ></img>
              </a>
            </div>
            <div className="">
              <a
                onClick={() => {
                  sendGAEvent({
                    eventName:
                      newsData?.type === "video"
                        ? "VideoPage-WhatsappShare"
                        : "ArticlePage-WhatsappShare",
                    pageTitle: newsData?.title,
                    pageLocation: `${websiteUrl}${newsData?.seo_detail?.canonical_url}`,
                  });
                }}
                target="_blank"
                href={siteInfo?.socialLinks?.whatsappChannel}
              >
                <img
                  src={asset_url + "/followwhatsappnew.png"}
                  width="270px"
                  height={60}
                  loading="lazy"
                  alt="follow on whatsapp"
                ></img>
              </a>
            </div>
          </div> */}

          {scrolled && (
            <div className="mx-4">
              <AdSlot300x250
                divId="div-gpt-ad-1659435474737-0"
                minWidth="300px"
                minHeight="250px"
              />
              <AdSlot728x90
                divId="div-gpt-ad-1659425743360-0"
                minWidth="728px"
                minHeight="90px"
              />
            </div>
          )}
        </div>
      )}
      {!isPhotoGallery && (
        <div>
          {isLiveBlog && (
            <div className="h-7 mr-2 px-2 py-1 bg-red-500 bg-opacity-20 rounded-2xl justify-start items-start inline-flex align-middle">
              {!isLiveEnded && (
                <img
                  src={asset_url + "/liveicon.gif"}
                  alt="live blog active"
                  loading="lazy"
                  width="14"
                  height="14"
                  className="pr-[-10px] mt-[3px]"
                />
              )}
              <div
                className={`${isRajasthan
                  ? "text-rajasthanDark"
                  : isMadhya
                    ? "text-mpDark"
                    : isHR
                      ? "text-hrDark"
                      : isBH
                        ? "text-biharDark"
                        : isUP
                          ? "text-upDark"
                          : isUP
                            ? "text-upDark"
                            : isCGH
                              ? "text-mpDark"
                              : isUK
                                ? "text-ukDark"
                                : "text-primary"
                  } text-sm`}
              >
                {textLanguage.liveBlog}
              </div>
            </div>
          )}
          <div className="text-2xl font-bold my-2">
            <h1
              style={{ lineHeight: "30px" }}
              dangerouslySetInnerHTML={{
                __html: `${newsData?.title}`,
              }}
            />
          </div>
          {isMobileDevice && (
            <div className="bg-white w-full border-gray-200 border-y ">
              {" "}
              {/* md:hidden */}
              <div className="flex items-center">
                {newsData?.author && newsData?.author[0] && (
                  <p
                    className={`${isRajasthan
                      ? "text-rajasthanDark"
                      : isMadhya
                        ? "text-mpDark"
                        : isHR
                          ? "text-hrDark"
                          : isBH
                            ? "text-biharDark"
                            : isUP
                              ? "text-upDark"
                              : isCGH
                                ? "text-mpDark"
                                : "text-primary"
                      } text-lg font-semibold pr-1`}
                  >
                    <a
                      href={
                        websiteUrl +
                        (newsData?.author[0]?.canonical_url ??
                          defaultAuthor.canonical_url)
                      }
                    >
                      <h4 className={`font-semibold ${styles.author_text}`}>
                        {newsData?.author[0]?.title ?? defaultAuthor.title}
                      </h4>
                    </a>
                  </p>
                )}
                {!newsData?.author ||
                  (!newsData?.author.length && (
                    <p
                      className={`${isRajasthan
                        ? "text-rajasthanDark"
                        : isMadhya
                          ? "text-mpDark"
                          : isHR
                            ? "text-hrDark"
                            : isBH
                              ? "text-biharDark"
                              : isUP
                                ? "text-upDark"
                                : isCGH
                                  ? "text-mpDark"
                                  : isUK
                                    ? "text-ukDark"
                                    : "text-primary"
                        } text-lg font-semibold pr-1`}
                    >
                      <a href={websiteUrl + defaultAuthor.canonical_url}>
                        <h4 className="font-semibold">{defaultAuthor.title}</h4>
                      </a>
                    </p>
                  ))}
                {newsData?.datetime_updated ===
                  newsData?.datetime_published && (
                    <time
                      className={`text-gray-500 font-light ${styles.author_text}`}
                    >
                      {publishedDateFormat2(newsData?.datetime_updated)}
                    </time>
                  )}
                {newsData?.datetime_updated !==
                  newsData?.datetime_published && (
                    <time
                      className="text-slate-500 text-xs font-extralight"
                      style={{ fontSize: "13px" }}
                    >
                      {/* {console.log("first11", newsData?.datetime_updated)} */}
                      {publishedDateFormat(newsData?.datetime_published)}{" "}
                      (अपडेटेड:{" "}
                      {isLiveBlog
                        ? convertDateTime(
                          newsDataLive?.content[0]?.datetime_updated
                        )
                        : convertDateTime(newsData?.datetime_updated)}
                      )
                    </time>
                  )}
              </div>
            </div>
          )}
          {/** short description */}
          {/* <summary
            className={`hidden text-md text-slate-500 my-2 ${
              newsData?.type === "video" ? "md:block" : ""
            } ${newsData?.type !== "video" ? "xs:block" : ""}`}
          >
            <h2
              className="text-lg text-[#777] italic"
              dangerouslySetInnerHTML={{
                __html: `${newsData?.description_short}`,
              }}
            />
          </summary> */}
          {newsData?.type === "video" ? (
            ""
          ) : (
            <h2
              style={{ color: "#777", fontStyle: "italic" }}
              dangerouslySetInnerHTML={{
                __html: `${newsData?.description_short}`,
              }}
            />
          )}
          {newsData?.type !== "video" && (
            <div className="block md:hidden mx-4">
              <AdSlot300x250
                divId="div-gpt-ad-1659434453897-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
          )}
          {/* {newsData?.type !== "video" && ( */}
          <AdSlot728x90
            divId="div-gpt-ad-1659424515060-0"
            minWidth="728px"
            minHeight="90px"
          />
          {/* )} */}
          {/** hero image */}
          {newsData?.type !== "video" && (
            <div className="relative my-4">
                       <img
                          className="rounded-md"
                          src={`${newsData?.image_main}?size=768:432&format=webp&q=70`}
                          srcSet={`
                            ${newsData?.image_main}?size=360:203&format=webp&q=45 360w,
                            ${newsData?.image_main}?size=480:270&format=webp&q=55 480w,
                             
                          `}
                          sizes="
                            (max-width: 480px) 100vw,
                            (max-width: 768px) 100vw,
                            1200px
                          "
                          alt={newsData?.image_main_alt_text || siteInfo?.siteName}
                          title={newsData?.title}
                          fetchPriority="high"
                          loading="eager"
                          decoding="async"
                          width="1200"
                          height="675"
                        />

          
                        {newsData?.image_caption && (
                          <div className="absolute bottom-0 w-full bg-black bg-opacity-50 text-white text-sm p-2 rounded-md">
                            {newsData?.image_caption}
                          </div>
                        )}
                      </div>
          )}
          {/** video player */}
          {newsData?.type === "video" && (
            <div className="w-full  aspect-video  ">
             
              {/* implement vod player */}

              {  <VODPlayer content={{
                id: newsData?.id,
                title: newsData?.title,
                headingImageUrl: `${newsData?.image_main}?size=948:533`,
                assetFileLink: newsData?.hls_url[0]?.video_url,
                permaLink: process.env.NEXT_PUBLIC_WEBSITE_URL + newsData?.seo_detail?.canonical_url,
                publishDate: newsData?.datetime_published?.split(" ")[0],
                durationInMs: newsData?.duration ? (newsData?.duration * 1000) : 0,
                categoryName: newsData?.category_detail?.[0]?.title,
              }} />}
            </div>
          )}
          {newsData?.type === "video" && (
            <div className="mx-4">
              <AdSlot300x250
                divId="div-gpt-ad-1659434453897-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
          )}
          {newsData?.type === "video" && (
            <h2
              className={`text-md text-slate-500 my-2  `}
              dangerouslySetInnerHTML={{
                __html: `${newsData?.description_short}`,
              }}
            />
          )}
          {/** author detail with date time social share */}
          <div className="hidden md:flex items-center justify-between p-2 border-b">
            <div className="flex items-center">
              <a
                href={
                  websiteUrl +
                  (newsData?.author[0]?.canonical_url ??
                    defaultAuthor.canonical_url)
                }
              >
                <img
                  src={`${newsData?.author[0]?.image ?? defaultAuthor.image
                    }?size=40:40`}
                  alt="Author Profile"
                  width={40}
    height={40}
    className="w-10 h-10 rounded-full mr-4"
    loading="eager"
    decoding="async"
                />
              </a>

              <div>
                <a
                  href={
                    websiteUrl +
                    (newsData?.author[0]?.canonical_url ??
                      defaultAuthor?.canonical_url)
                  }
                >
                  <h4
                    className={`${isRajasthan
                      ? "text-rajasthanDark"
                      : isMadhya
                        ? "text-mpDark"
                        : isHR
                          ? "text-hrDark"
                          : isBH
                            ? "text-biharDark"
                            : isUP
                              ? "text-upDark"
                              : isCGH
                                ? "text-mpDark"
                                : isUK
                                  ? "text-ukDark"
                                  : "text-primary"
                      } font-semibold`}
                  >
                    {newsData?.author[0]?.title ?? defaultAuthor?.title}
                  </h4>
                </a>

                <time className="text-slate-500 text-xs font-extralight">
                  {/* {console.log("first12", newsData?.datetime_updated)} */}
                  {publishedDateFormat(
                    newsData?.datetime_published
                  )} (अपडेटेड:{" "}
                  {isLiveBlog
                    ? convertDateTime(
                      newsDataLive?.content[0]?.datetime_updated
                    )
                    : convertDateTime(newsData?.datetime_updated)}
                  )
                </time>
              </div>
            </div>

            <SocialShare
              title={newsData?.title}
              url={`${websiteUrl}${newsData?.seo_detail?.canonical_url}`}
              contentType={newsData?.type}
              isRajasthan={isRajasthan}
              isMadhya={isMadhya}
              isHR={isHR}
              isBH={isBH}
              isUP={isUP}
              isCGH={isCGH}
              isUK={isUK}
            />
          </div>
          <div className="flex md:hidden items-center justify-between   border-b">
            <SocialShare
              title={newsData?.title}
              url={`${websiteUrl}${newsData?.seo_detail?.canonical_url}`}
              contentType={newsData?.type}
              isRajasthan={isRajasthan}
              isMadhya={isMadhya}
              isHR={isHR}
              isBH={isBH}
              isUP={isUP}
              isCGH={isCGH}
              isUK={isUK}
            />

            <a
              href={siteInfo?.socialLinks?.googleNewsLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                sendGAEvent({
                  eventName:
                    newsData?.type === "video"
                      ? "VideoPage-GoogleNewsClick"
                      : "ArticlePage-GoogleNewsClick",
                  pageTitle: newsData?.title,
                  pageLocation: `${websiteUrl}${newsData?.seo_detail?.canonical_url}`,
                });
              }}
           
            >
               <img
                className="rounded-md"
                loading="eager"
                // src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/followGoogleNews.png?size=130:58"
                src={"https://akm-img-a-in.tosshub.com/lingo/uptak/resources/google.png?size=120:45"}
                alt="google news"
            width="120"
              height="45"
              />
            </a>
          </div>

          {showHighLight && (
            <HighLights
              highlights={newsData?.highlight}
              isRajasthan={isRajasthan}
              isMadhya={isMadhya}
              isHR={isHR}
              isBH={isBH}
              isUP={isUP}
              isCGH={isCGH}
              isUK={isUK}
            />
          )}
          {/** news detail */}
          {/* <div
          className={`my-4 font-extralight text-gray-700 ${styles.newsDetail}`}
          dangerouslySetInnerHTML={{
            __html: newsData?.description,
          }}
        /> */}
          {
            <section
              className={`my-4 font-extralight text-gray-700 ${isRajasthan
                ? styles.rajasthanNewsDetail
                : isMadhya
                  ? styles.mpNewsDetail
                  : isHR
                    ? styles.hrNewsDetail
                    : isBH
                      ? styles.bhNewsDetail
                      : isCGH
                        ? styles.mpNewsDetail
                        : isUK
                          ? styles.ukNewsDetail
                          : styles.newsDetail
                }`}
            >

              {newsData?.type === "live_blog" && newsData?.election_livetv?.length > 0 && (
                // <div className="top-layer-election" style={{ position: "sticky" }}>
                //   <ElectionLive
                //     electionLiveData={electionLiveData?.content}
                //     firstActive={firstActive}
                //   />
                // </div>

                <div
                  className="
                          relative 
                          h-[220px]       
                          md:h-[456px]  
                          overflow-hidden
                          rounded-lg
                          mt-2
                      align-center
                        "
                >
                  <div
                    className="[&>iframe]:absolute [&>iframe]:top-0 [&>iframe]:left-0 [&>iframe]:w-full [&>iframe]:h-full"
                    dangerouslySetInnerHTML={{ __html: newsData?.election_livetv }}
                  />
                </div>


              )}
              {paragraphs[0] && (
                <section
                  dangerouslySetInnerHTML={{ __html: paragraphs[0] + "</p>" }}
                ></section>
              )}
              {newsData?.type === "video" && scrolled && (
                <div className="mx-4">
                  <AdSlot300x250
                    divId="div-gpt-ad-1659434604998-0"
                    minWidth="300px"
                    minHeight="250px"
                  />
                  <AdSlot728x90
                    divId="div-gpt-ad-1707804176041-2"
                    minWidth="720px"
                    minHeight="90px"
                  />
                </div>
              )}
              {/** read more button */}
              {/* {((paragraphs[1] || (newsData?.related_story?.length > 0 ||
              newsData?.related_content?.length > 0))) && (newsData?.type == "story")&&<button onClick={() => setShowMore(prev => !prev)} hidden={!showMore} className="ms-[35%] md:ms-[45%] font-bold text-[18px] rounded w-[7rem] h-8 my-6 border border-primary text-primary p-1">
            पूरा लेख पढ़ें
          </button>} */}

              <div>
                {paragraphs[1] && (
                  <section
                    dangerouslySetInnerHTML={{ __html: paragraphs[1] + "</p>" }}
                  ></section>
                )}
                {/* {isMobileDevice && paragraphs[2] ? (
              <>
                <VDOAdSlot />
              </>
            ) : (
              paragraphs[2] && (
                <>
                  <VDOAdSlot />
                </>
              )
            )} */}
                {paragraphs[2] && (
                  <section
                    dangerouslySetInnerHTML={{
                      __html: paragraphs[2] + "</p>",
                    }}
                  ></section>
                )}
                {/** related news */}

                {newsData?.type !== "breaking_new" &&
                  newsData?.type !== "live_blog" && (
                    <>
                      {paragraphs[4] && scrolled && (
                        <div className="mx-4">
                          <AdSlot300x250
                            divId={
                              newsData?.type === "video"
                                ? "div-gpt-ad-1659434785315-0"
                                : "div-gpt-ad-1659434604998-0"
                            }
                            minWidth="300px"
                            minHeight="250px"
                          />
                        </div>
                      )}
                      {newsData?.type !== "video" && scrolled && (
                        <AdSlot728x90
                          divId={"div-gpt-ad-1707804176041-2"}
                          minWidth="720px"
                          minHeight="90px"
                        />
                      )}
                    </>
                  )}
                {scrolled && (newsData?.related_story?.length > 0 ||
                  newsData?.related_content?.length > 0) && (
                    <RelatedNews
                      relatedNewsData={
                        newsData?.related_story || newsData?.related_content
                      }
                    />
                  )}

                {paragraphs[3] && (
                  <section
                    dangerouslySetInnerHTML={{
                      __html: paragraphs[3] + "</p>",
                    }}
                  ></section>
                )}
                {paragraphs[4] && (
                  <section
                    dangerouslySetInnerHTML={{
                      __html: paragraphs[4] + "</p>",
                    }}
                  ></section>
                )}

                {!(newsData?.content?.length > 4) &&
                  paragraphs[5] &&
                  scrolled && (
                    <>
                      <div className="mx-4">
                        <AdSlot300x250
                          divId={
                            newsData?.type === "video"
                              ? "div-gpt-ad-1659435328239-0"
                              : "div-gpt-ad-1659434785315-0"
                          }
                          minWidth="300px"
                          minHeight="250px"
                        />
                      </div>
                      <AdSlot728x90
                        divId="div-gpt-ad-1707804176041-3"
                        minWidth="728px"
                        minHeight="90px"
                      />
                    </>
                  )}
                {paragraphs[5] && (
                  <section
                    dangerouslySetInnerHTML={{
                      __html: paragraphs[5] + "</p>",
                    }}
                  ></section>
                )}
                {paragraphs && paragraphs[6] && scrolled && (
                  <div className="mx-4">
                    <AdSlot300x250
                      divId="div-gpt-ad-1659435328239-0"
                      minWidth="300px"
                      minHeight="250px"
                    />
                  </div>
                )}
                {paragraphs[6] && (
                  <section
                    dangerouslySetInnerHTML={{
                      __html: paragraphs[6] + "</p>",
                    }}
                  ></section>
                )}
                {/* 
            {!(newsData?.content?.length > 4) && paragraphs[6] && (
              <>
                <AdSlot728x90
                  divId="div-gpt-ad-1707462042346-0"
                  minWidth="728px"
                  minHeight="90px"
                />
              </>
            )} */}
                <section
                  dangerouslySetInnerHTML={{
                    __html: stringSplit(paragraphs?.slice(7)),
                  }}
                ></section>
              </div>
              {isLiveEnded && <p>{textLanguage.liveEnded}</p>}
              <ul className={`my-2 ${styles.liveDetail}`}>
                {newsDataLive?.content &&
                  newsDataLive?.content?.map((liveEvent, index) => {
                    return (
                      <Fragment key={index}>
                        {/* {index === 2 &&
                        size.width !== undefined &&
                        (size.width < 900 ? (
                          <>
                            <VDOAdSlot />
                          </>
                        ) : (
                          <>
                            <VDOAdSlot />
                          </>
                        ))} */}
                        {index === 2 && scrolled && (
                          <>
                            <div className="mx-4">
                              <AdSlot300x250
                                divId="div-gpt-ad-1659434604998-0"
                                minWidth="300px"
                                minHeight="250px"
                              />
                            </div>
                            <AdSlot728x90
                              divId="div-gpt-ad-1707804176041-2"
                              minWidth="728px"
                              minHeight="90px"
                            />
                          </>
                        )}
                        {index === 6 && scrolled && (
                          <>
                            <div className="mx-4">
                              <AdSlot300x250
                                divId="div-gpt-ad-1659434785315-0"
                                minWidth="300px"
                                minHeight="250px"
                              />
                            </div>
                            <AdSlot728x90
                              divId="div-gpt-ad-1707804176041-3"
                              minWidth="728px"
                              minHeight="90px"
                            />
                          </>
                        )}
                        <LiveBlog
                          id={liveEvent.id}
                          liveEvent={liveEvent}
                          isMadhya={isMadhya}
                          isRajasthan={isRajasthan}
                          isBH={isBH}
                          isUP={isUP}
                          isHR={isHR}
                          isCGH={isCGH}
                          isUK={isUK}
                        />
                      </Fragment>
                    );
                  })}

              </ul>
              {isAutoLiveBlog   &&newsDataLive?.content?.length > 19 && hasMore != 0 && (
                <div className="justify-items-center">
                  <div
                    className={` ${isRajasthan
                      ? "bg-rajasthanDark"
                      : isMadhya
                        ? "bg-mpDark"
                        : isHR
                          ? "bg-hrDark"
                          : isBH
                            ? "bg-biharDark"
                            : isUP
                              ? "bg-upDark"
                              : isCGH
                                ? "bg-mpDark"
                                : isUK
                                  ? "bg-ukDark"
                                  : "bg-primary"
                      } flex align-middle py-[10px] my-4 px-4 rounded-full 
                   justify-center items-center text-white 
                 cursor-pointer m-auto w-fit`}
                    onClick={fetchMoreEvents}
                  >
                    <img
                      src="https://akm-img-a-in.tosshub.com/lingo/sportstak-frontend/resources/prod/sports-static-images/rotate-right.png"
                      className="h-5 w-5 mr-2"
                      loading="lazy"
                    />
                    {loading ? "Loading..." : "Load More"}
                  </div>
                </div>
              )}

            </section>
          }
          <div className="desktop-only-flex flex items-center my-4">
            {/* <div className="self-center text-center md:mr-8 mb-4 md:mb-0 mr-0">
              <a
                onClick={() => {
                  sendGAEvent({
                    eventName:
                      newsData?.type === "video"
                        ? "VideoPage-GoogleNewsClick"
                        : "ArticlePage-GoogleNewsClick",
                    pageTitle: newsData?.title,
                    pageLocation: `${websiteUrl}${newsData?.seo_detail?.canonical_url}`,
                  });
                }}
                target="_blank"
                href={siteInfo?.socialLinks?.googleNewsLink}
              >
                <img
                  src={asset_url + "/followgooglenew.png?size=110:40"}
                  width="270px"
                  height={60}
                  loading="lazy"
                  alt="follow on google news"
                ></img>
              </a>
            </div> */}
            {/* <div className="">
              <a
                onClick={() => {
                  sendGAEvent({
                    eventName:
                      newsData?.type === "video"
                        ? "VideoPage-WhatsappShare"
                        : "ArticlePage-WhatsappShare",
                    pageTitle: newsData?.title,
                    pageLocation: `${websiteUrl}${newsData?.seo_detail?.canonical_url}`,
                  });
                }}
                target="_blank"
                href={siteInfo?.socialLinks?.whatsappChannel}
              >
                <img
                  src={asset_url + "/followwhatsappnew.png"}
                  width="270px"
                  height={60}
                  loading="lazy"
                  alt="follow on whatsapp"
                ></img>
              </a>
            </div> */}
          </div>
          {/* <div className="whatsapp-sticky mobile-only">
          <a
            target="_blank"
            href={siteInfo?.socialLinks?.whatsappChannel}
            style={{ display: "flex", width: "fit-content" }}
          >
            <span>सब्सक्राइब करें</span>
            <img
              src="https://mcmscache.epapr.in/post_images/website_51/new_post_images/5c0e905f1fcd0_whatsapp.png"
              width="20px"
            />
          </a>
        </div> */}
          {/* <div className="googlenews-sticky mobile-only">
          <a target="_blank" href={siteInfo?.socialLinks?.googleNewsLink}>
            <img
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/followGoogleNew.png"
              width="40px"
              height="40px"
            ></img>
          </a>
        </div> */}
          {/* <div className="py-2 md:hidden flex justify-center">
          <a
            href={siteInfo?.socialLinks?.whatsappChannel}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="rounded-md"
              loading="lazy"
              width="360"
              height="70"
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/followWhatsAppNew.png"
              alt="follow whatsapp"
            />
          </a>
        </div>

        {/** tags */}
          {/* {newsData?.tags && (
          <div className="my-4">
            <div className="text-slate-800 text-lg font-bold">
              <h4>Related Hashtags</h4>
            </div>
            <div className="flex flex-wrap gap-2 py-2">
              {newsData?.tags?.map((item, index) => (
                <a href={item?.canonical_url} key={index}>
                  <div className="border border-primary rounded-md px-2 py-1 text-slate-700 text-xs font-semibold">
                    {item?.title}
                  </div>
                </a>
              ))}
            </div>
          </div>
        )} */}
          {scrolled && (
            <div className="mx-4">
              <AdSlot300x250
                divId="div-gpt-ad-1659435474737-0"
                minWidth="300px"
                minHeight="250px"
              />
              <AdSlot728x90
                divId="div-gpt-ad-1659425743360-0"
                minWidth="728px"
                minHeight="90px"
              />
            </div>
          )}
          {/* <div id="M887407ScriptRootC1469369"></div> */}
        </div>
      )}
</article>
      <div id="endDiv"></div>

      {/* {scrolled && <div data-type="_mgwidget" data-widget-id="1584885"></div>}
      {scrolled && (
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      )} */}
      {scrolled && (
        <div id={`taboola-below-${taboolaPage}-thumbnails-${isMobileDevice ? "mobile" : "desktop"}`}></div>
      )}
      {showRecEngine && recArticles?.length > 0 && (
        <RecengineWidget
          articles={recArticles}
          isRajasthan={isRajasthan}
          isMadhya={isMadhya}
          isHR={isHR}
          isBH={isBH}
          isUP={isUP}
          isCGH={isCGH}
          isUK={isUK}
        />
      )}
    </section>
  );
};

export default Detail;
